<div class="header-panel">
  <div class="header-left-panel">
    <img src="assets/images/EcolabLogo.svg" alt="Ecolab Title" class="link" />
  </div>
</div>

<div class="align-content">
      <p> Sorry, but you currently do not have access to Order Tracking.</p>
      <p> This instance of Order Tracking is intended for non-Sales organizational use. If you need this access and are not a Field Sales representative, please request access by filling this form out:
        <a class="font-color" (click)="navigateToservicenow()">Genius Web Access Request</a>.
      </p>
      <p>As a Field Sales representative, you can use the Order Tracking Mobile application at
        <a class="font-color" (click)="navigateToAthenaMobileApp()"> https://whereismyorder.ecolab.com</a>.</p>
  </div>
<div>
  <router-outlet></router-outlet>
</div>




